import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { I18nProvider } from './i18n/I18nContext.jsx';
import LangLayout from './components/LangLayout.jsx';
import LangRedirect from './components/LangRedirect.jsx';
import LandingPage from './pages/LandingPage.jsx';
import LoginPage from './pages/LoginPage.jsx';
import DashboardPage from './pages/DashboardPage.jsx';
import ConnectorPage from './pages/ConnectorPage.jsx';
import BillingPage from './pages/BillingPage.jsx';
import PrivacyPage from './pages/PrivacyPage.jsx';
import TermsPage from './pages/TermsPage.jsx';
import PricingPage from './pages/PricingPage.jsx';
import ContactPage from './pages/ContactPage.jsx';
import NotFoundPage from './pages/NotFoundPage.jsx';
import AuthGuard from './components/AuthGuard.jsx';
import NavBar from './components/NavBar.jsx';

export default function App() {
  return (
    <BrowserRouter>
      <I18nProvider>
        <a href="#main-content" className="skip-to-content">Skip to main content</a>
        <Routes>
          {/* ── Bare paths (no lang prefix) → redirect to /:lang equivalent ── */}
          <Route path="/" element={<LangRedirect />} />
          <Route path="/pricing" element={<LangRedirect />} />
          <Route path="/contact" element={<LangRedirect />} />
          <Route path="/privacy" element={<LangRedirect />} />
          <Route path="/terms" element={<LangRedirect />} />
          <Route path="/login" element={<LangRedirect />} />
          <Route path="/dashboard" element={<LangRedirect />} />
          <Route path="/connector" element={<LangRedirect />} />
          <Route path="/billing" element={<LangRedirect />} />

          {/* ── Language-prefixed routes ── */}
          <Route path="/:lang" element={<LangLayout />}>
            {/* Public marketing pages */}
            <Route index element={<LandingPage />} />
            <Route path="pricing" element={<PricingPage />} />
            <Route path="contact" element={<ContactPage />} />
            <Route path="privacy" element={<PrivacyPage />} />
            <Route path="terms" element={<TermsPage />} />

            {/* Auth */}
            <Route path="login" element={<LoginPage />} />

            {/* Protected app pages */}
            <Route
              path="dashboard"
              element={
                <AuthGuard>
                  <NavBar />
                  <DashboardPage />
                </AuthGuard>
              }
            />
            <Route
              path="connector"
              element={
                <AuthGuard>
                  <NavBar />
                  <ConnectorPage />
                </AuthGuard>
              }
            />
            <Route
              path="billing"
              element={
                <AuthGuard>
                  <NavBar />
                  <BillingPage />
                </AuthGuard>
              }
            />

            {/* 404 within a valid lang prefix */}
            <Route path="*" element={<NotFoundPage />} />
          </Route>

          {/* 404 for completely unknown paths */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </I18nProvider>
    </BrowserRouter>
  );
}
